import { render } from "./MultiSensorManage.vue?vue&type=template&id=319ada40&scoped=true"
import script from "./MultiSensorManage.vue?vue&type=script&lang=js"
export * from "./MultiSensorManage.vue?vue&type=script&lang=js"

import "./MultiSensorManage.vue?vue&type=style&index=0&id=319ada40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319ada40"]])

export default __exports__